type ProfileLike = {
  firstName?: string;
  name?: string;
};

export default function extractNameFromProfileLike(profile: ProfileLike) {
  if (profile.firstName && profile.name) {
    return profile.name;
  }
  const match = profile.name
    ? profile.name
        .replace(/\(.+?\)/g, '')
        .trim()
        .match(
          /^.+?\s+((?:(?:van\s+der\s+)|(?:de\s+la\s+)|(?:van\s+)|(?:de\s+))?[^\s]+)$/i
        )
    : null;
  if (match) {
    return match[1];
  }
  return null;
}
